/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Ex_NoteInputs */

const en_minifier_ex_note = /** @type {(inputs: Minifier_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The two spaces in "New York" survive because they are part of the string. Every other space, newline, and indent is gone.`)
};

const ko_minifier_ex_note = /** @type {(inputs: Minifier_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"New York"의 공백은 문자열의 일부이므로 살아남습니다. 그 밖의 모든 공백, 줄바꿈, 들여쓰기는 사라졌습니다.`)
};

const ja_minifier_ex_note = /** @type {(inputs: Minifier_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"New York" の空白は文字列の一部なので生き残ります。それ以外のすべての空白、改行、インデントは消えました。`)
};

/**
* | output |
* | --- |
* | "The two spaces in \"New York\" survive because they are part of the string. Every other space, newline, and indent is gone." |
*
* @param {Minifier_Ex_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_ex_note = /** @type {((inputs?: Minifier_Ex_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Ex_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_ex_note(inputs)
	if (locale === "ko") return ko_minifier_ex_note(inputs)
	return ja_minifier_ex_note(inputs)
});